import api from './api';

const reklamSliderService = {
    // Public endpoint - get active sliders
    getActiveSliders: () => {
        return api.get('/reklam-sliders');
    },

    // Admin endpoints
    getAllSliders: () => {
        return api.get('/reklam-sliders/all');
    },

    getSlider: (id) => {
        return api.get(`/reklam-sliders/${id}`);
    },

    createSlider: (formData) => {
        return api.post('/reklam-sliders', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    updateSlider: (id, formData) => {
        return api.put(`/reklam-sliders/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    deleteSlider: (id) => {
        return api.delete(`/reklam-sliders/${id}`);
    },

    toggleSlider: (id) => {
        return api.patch(`/reklam-sliders/${id}/toggle`);
    }
};

export default reklamSliderService;
